import { render, staticRenderFns } from "./PiniaExampleComponent.vue?vue&type=template&id=4b7a61c9&scoped=true&"
import script from "./PiniaExampleComponent.vue?vue&type=script&lang=js&"
export * from "./PiniaExampleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a61c9",
  null
  
)

export default component.exports